

$('.country-selector__stat').click(function(e){
    e.stopPropagation();
    $('.country-selector__items').toggleClass('show-selector');
});

$(document).click(function(){
    $('.country-selector__items').removeClass('show-selector');
});

// $('.country-selector__name').click(function(e){
//     e.stopPropagation();
//     $('.country-selector__items').toggleClass('show-selector');
// });


// $('.main-variant').on('change', function() {
//     var var_status = $(this).find('option:selected').attr('disabled');
//     console.log('found: ' + var_status);
//   });

 


var my_pick = {};
        if ($("select.styled-select").length) {
            $("select.styled-select").selectric({
                onChange: function(element) {
                    $(element).change();
                    var variant = "";
                    console.log($(this).val());
                    $(this).parent().parent().parent().parent().find('.selected-product').each(function(index){
                        my_pick[index] = $(this).val();
                        variant += '[option' + index + '="' + my_pick[index] + '"]';
                    });

                    console.log(variant);
                    console.log('checking checking');

                    $('.main-variant option').attr("selected", false);
                    $(variant).attr("selected", true);
                    



                    var selected_price = $('.main-variant option:selected').attr('data-price');
                    var selected_variant = $('.main-variant option:selected').attr('discount-variant');
                    var my_chosen_variant = $('.main-variant option:selected').attr('value');

                    if(my_chosen_variant == '39774516772941' || my_chosen_variant == '39832172134477' 
                    || my_chosen_variant == '39832176296013' || my_chosen_variant == '39961166381133'  ||
                    my_chosen_variant == '39832172822605' || my_chosen_variant == '39832177147981' || my_chosen_variant == '40015014232141'){
                        selected_plan = 'false';
                        $('.only-subscription .plan__input').prop("checked", false);
                        $('.only-once .plan__input').prop("checked", true);
                        $('.plan-bg-pink').removeClass('plan-bg-pink');
                        $('.subcribe-wrap').addClass('hide-subscription');
                    }else{
                        $('.subcribe-wrap').removeClass('hide-subscription');
                    }

                    if(selected_plan == 'false'){
                        $('.variant-price').text($('.main-variant option:selected').attr('data-price'));
                        $('.subscribe-input-row span.hidden').text($('.main-variant option:selected').attr('data-price'));
                        $('.discounter-price').text($('.main-variant option:selected').attr('discount-price'));
                    }else{
                        $('.variant-price').text($('.main-variant option:selected').attr('discount-price'));
                        $('.discounter-price').text($('.main-variant option:selected').attr('discount-price'));
                        $('.subscribe-input-row span.hidden').text($('.main-variant option:selected').attr('data-price'));        
                    }
                    $('.main-variant').attr('data-productid', selected_variant);
                    console.log(selected_price);
                    console.log('chosen var:'+ my_chosen_variant);
                    console.log("available: " + $(variant).attr('disabled'));
                    var stock_stat = $(variant).attr('disabled');
                    if(stock_stat == 'disabled'){
                        $('.add-cart-btn').addClass('disabled');
                    }else{
                        $('.add-cart-btn').removeClass('disabled');
                    }


                  },
            });
        }